module.exports = __webpack_public_path__ + "img/export-sestava.40708d7a.png";